import { render, staticRenderFns } from "./product-download.vue?vue&type=template&id=24490e64&scoped=true&"
import script from "./product-download.vue?vue&type=script&lang=js&"
export * from "./product-download.vue?vue&type=script&lang=js&"
import style0 from "./product-download.vue?vue&type=style&index=0&id=24490e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24490e64",
  null
  
)

export default component.exports